<div *ngIf="isJsonShow">
  {{decisionForm.value | json}}
</div>

<div class="action-cards-container">
  <div class="row">
    <!-- Change State Card -->
    <div class="col-md-4 mb-3">
      <div class="action-card" (click)="openChangeStateModal()">
        <div class="card-icon change-state-icon">
          <i class="fas fa-exchange-alt"></i>
        </div>
        <div class="card-title">Change State <span class="text-danger">*</span></div>
        <div class="card-description">Update the application state</div>
      </div>
    </div>

    <!-- Add Notes Card -->
    <div class="col-md-4 mb-3">
      <div class="action-card" (click)="openAddNotesModal()">
        <div class="card-icon add-notes-icon">
          <i class="fas fa-sticky-note"></i>
        </div>
        <div class="card-title">Add Notes</div>
        <div class="card-description">Add notes to this application</div>
      </div>
    </div>

    <!-- Send to First Aid Card -->
    <div class="col-md-4 mb-3">
      <div class="action-card" (click)="openSendToFirstAidModal()">
        <div class="card-icon first-aid-icon">
          <i class="fas fa-first-aid"></i>
        </div>
        <div class="card-title">Send to First Aid</div>
        <div class="card-description">Send application to first aid</div>
      </div>
    </div>
  </div>
</div>

<!-- Back Button -->
<div class="text-center mt-4">
  <button class="btn btn-secondary" type="button" (click)="goBack()">Back</button>
</div>
